<template>
    <div>
        <div class="card">
            <Toolbar class="mb-4">
                <template slot="left">
                    <label>PLANILLA MENSUAL DEL SERVICIO</label>
                </template>
            </Toolbar>
			<br>
			<Toolbar class="mb-4">
                <template slot="left">
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field col-md-2">
							<label for="anio">Año</label>
							<Dropdown id="anio" 
								style="width:120px;"
								:filter="false" 
								:options="anioLista" 
								v-model="anioSeleccionado"
								optionLabel="anio" 
								dataKey="id"
								placeholder="Seleccionar Año">
							</Dropdown>
						</div>
						<div class="p-field col-md-2" style="margin-left: 10px">
							<label for="mes">Mes</label>
							<Dropdown id="mes" 
								style="width:120px;"
								:filter="false" 
								:options="mesLista" 
								v-model="mesSeleccionado"
								optionLabel="mes" 
								dataKey="id"
								placeholder="Seleccionar Mes">
							</Dropdown>
						</div>
						<div class="p-field col-md-2" style="margin-left: 10px">
							<label for="buscar">&nbsp;&nbsp;</label>
							<div class="col-md-2">
								<Button id="buscar" icon="pi pi-search" style="width:100px;" class="p-button-primary" @click='buscarClientes' />
							</div>							
						</div>
					</div>
                </template>
            </Toolbar>
			<DataTable
				v-if="disbleClientes"
                class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                :value="dataClientes"
                :rowHover="true"
                dataKey="id"
                :paginator="true"
                :rows="100"
                :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                <template #header>
                    <div class="table-header">
                        <h5 class="p-m-0"> {{ tituloTabla }}  </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filters['global']" placeholder="Buscar..." />
                        </span>
                    </div>
                </template>
                <template #empty> No se encontraron Registros. </template>
                <template #loading> Cargando Registros, por favor espere un momento. </template>
                <Column field="cedula" header="Cédula" headerStyle="width: 9em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Cédula:</span>
                        {{ slotProps.data.cedula }}
                    </template>
                </Column>
                <Column field="nombres" header="Nombres">
                    <template #body="slotProps">
                        <span class="p-column-title"> Nombres:</span>
                        <span  :class="'customer-badge'">{{slotProps.data.nombres}} </span>
                    </template>
                </Column>
				<Column field="apellidos" header="Apellidos">
                    <template #body="slotProps">
                        <span class="p-column-title"> Apellidos:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.apellidos }} </span>
                    </template>
                </Column>
                <Column field="numeromedidor" header="No. Medidor" headerStyle="width: 15em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> No. Medidor:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.numeromedidor }} </span>
                    </template>
                </Column>
				<Column field="lecturatomada" header="Estado" headerStyle="width: 7em;" >
					<template #body="slotProps">
						<span class="p-column-title"> Estado </span>
						<span v-if="slotProps.data.lecturatomada == 'O'" :class="'customer-badge status-1'">LISTO</span>
						<span v-else :class="'customer-badge status-0'">FALTA</span>
					</template>
				</Column>
                <Column headerStyle="width: 10em;">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-primary p-mr-2" v-tooltip="'Registrar consumo mensual'" @click="registrarConsumo(slotProps.data)" />
						<Button icon="pi pi-file-pdf" class="p-button-rounded p-button-success p-mr-2" v-tooltip="'Imprimir planilla de consumo'" @click="imprimirPlanilla(slotProps.data)" />
						<Button icon="pi pi-file" class="p-button-rounded p-button-help p-mr-2" v-tooltip="'Registrar valores adicionales'" @click="valoresAdicionales(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </div>
		<Dialog :visible.sync="regitrarPlanillaDialog" :style="{ width: '600px' }" :header="tituloRegistroPlanilla" :modal="true" position="top">
			<RegistroPlanilla
				ref="RegistroPlanilla"
				:cliente = "clienteSeleccionado"
				:mes = "mesSeleccionado"
				:anio = "anioSeleccionado"
				@cerrarModal="cerrarModal"
			></RegistroPlanilla>
		</Dialog>
		<Dialog :visible.sync="regitrarValoresAdicionalesDialog" :style="{ width: '700px' }" :header="tituloValoresAdicionales" :modal="true" position="top">
			<ValoresAdicionalesPlanilla
				ref="ValoresAdicionalesPlanilla"
				:cliente = "clienteSeleccionado"
				:mes = "mesSeleccionado"
				:anio = "anioSeleccionado"
				@valoresadicional="valoresAdicionales"
			></ValoresAdicionalesPlanilla>
		</Dialog>
		<DialogProgreso
            :showProgreso="showProgreso"
            :titulo="mensajeCargando">
        </DialogProgreso>
	</div>
</template>
<script>
import AnioService from "../../service/administracion/AnioService";
import MesService from "../../service/administracion/MesService";
import ClienteService from "../../service/administracion/ClienteService";
import Swal from 'sweetalert2';
import Globals from "../../js/Globales";
import RegistroPlanilla from "./Componentes/RegistroPlanilla.vue";
import ValoresAdicionalesPlanilla from "./Componentes/ValoresAdicionalesPlanilla.vue";
import DialogProgreso from "../componentesglobales/DialogoProgreso.vue";
import PlanillaService from "../../service/administracion/PlanillaService";

export default {
	data() {
		return {
			anioLista: [],
			anioSeleccionado: {},
			mesLista: [],
			mesSeleccionado: {},
			dataClientes: [],
			filters: {},
			position: "top",
			rango: Globals[0].paginacion.rango,
			disbleClientes: false,
			tituloTabla: null,
			regitrarPlanillaDialog: false,
			clienteSeleccionado: {},
			tituloRegistroPlanilla: null,
			showProgreso: null,
            mensajeCargando: null,

			regitrarValoresAdicionalesDialog: false,
			tituloValoresAdicionales: null
		}
	},
	anioService: null,
	mesService: null,
	clienteService: null,
	planillaService: null,
	created() {
		this.anioService = new AnioService();
		this.mesService = new MesService();
		this.clienteService = new ClienteService();
		this.planillaService = new PlanillaService();
	},
	mounted() {
		this.cargarAnio();
		this.cargarMes();
	},
	components: {
		'RegistroPlanilla' : RegistroPlanilla,
		'DialogProgreso': DialogProgreso,
		'ValoresAdicionalesPlanilla': ValoresAdicionalesPlanilla
	},
	methods: {
		buscarClientes(){
			if(Object.keys(this.anioSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			if(Object.keys(this.mesSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			this.dataClientes = [];
			Swal.fire({
                title: 'Cargando...',
                html: 'por favor, espere!...',
                allowOutsideClick: false,
                didOpen: () => {
					Swal.showLoading()
				}
            });
			this.clienteService.buscarClientesPlanillar(this.anioSeleccionado.id, this.mesSeleccionado.id).then( response => {
				Swal.close();
				this.dataClientes = response.data;
				this.disbleClientes = true;
				this.showProgreso = false;
				this.tituloTabla = "Clientes - Planillar Mes: " + this.mesSeleccionado.mes + " Año: " + this.anioSeleccionado.anio;
			}).catch( error => {
				Swal.close();
				console.log(error);
			});
		},

		cargarAnio(){
			this.anioLista = [];
			this.anioService.buscaractivos().then( response => {
				this.anioLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

		cargarMes(){
			this.mesLista = [];
			this.mesService.buscaractivos().then( response => {
				this.mesLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

		hideDialogRegistroPlanilla(){
			this.regitrarPlanillaDialog = false;
		},

		registrarConsumo(cliente){
			if(cliente.lecturatomada == "O"){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "Lectura ya fue tomada", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
			this.regitrarPlanillaDialog = true;
			this.clienteSeleccionado = cliente;
			this.tituloRegistroPlanilla = "Cliente: " + cliente.nombres + " " + cliente.apellidos;
		},

		valoresAdicionales(cliente){
			if(cliente.lecturatomada == "X"){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "Primero debe registrar la lectura", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
			this.clienteSeleccionado = cliente;
			this.regitrarValoresAdicionalesDialog = true;
			this.tituloValoresAdicionales = "Valores adicionales - " + cliente.nombres + " " + cliente.apellidos;
		},

		cerrarModal(data){
			this.regitrarPlanillaDialog = false;
			this.clienteSeleccionado = {};
			this.tituloRegistroPlanilla = "";
			if(data != null){
				this.dataClientes.forEach(cl => {
					if(cl.id == data.id){
						cl.lecturatomada = "O";
					}
				})
			}
		},

		imprimirPlanilla(data){
			if(data.lecturatomada == "X"){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "No se ha registrado lectura", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
			Swal.fire({
                title: 'Generando planilla...',
                html: 'por favor, espere!...',
                allowOutsideClick: false,
                didOpen: () => {
					Swal.showLoading()
				}
            });
			this.planillaService.imprimirPlanilla(data.id,this.anioSeleccionado.id, this.mesSeleccionado.id).then(response => {
				Swal.close();
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Planilla-" + data.cedula + "-" + this.anioSeleccionado.anio + "-" + this.mesSeleccionado.mes;
                link.click();
				this.showProgreso = false;
            })
            .catch(() => {
            });
		}
	}
}
</script>
<style scoped lang="scss">
/deep/ .p-progressbar {
	height: .5rem;
	background-color: #D8DADC;
	.p-progressbar-value {
		background-color: #607D8B;
	}
}
.table-header {
	display: flex;
	justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-customers {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}
	.p-paginator {
		padding: 1rem;
	}
	.p-datatable-thead > tr > th {
		text-align: left;
	}
	.p-datatable-tbody > tr > td {
		cursor: auto;
	}
	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}
/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
    
    
}
.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-0 {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.status-1 {
		background: #B3E5FC;
		color: #23547B;
	}
	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}
	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}
.p-progressbar-value.ui-widget-header {
	background: #607d8b;
}
@media (max-width: 640px) {
	.p-progressbar {
		margin-top: .5rem;
	}
}
.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}
.orders-subtable {
	padding: 1rem;
}
.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}
.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}
	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}
	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	/deep/ .p-datatable {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}
			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;
					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}
					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}
</style>